import { NavLink, useNavigate } from "react-router-dom";
import { Bell, CalendarDays, ClipboardList, Home, UserRound, UsersRound } from "lucide-react";
import { AppLogo } from "@/components/Shared";
import { useAuth } from "@/context/AuthContext";
import { useRealtimeSync } from "@/lib/realtime";

const NAV = [
  { to: "/genitore", label: "Home", icon: Home, end: true },
  { to: "/genitore/figli", label: "Figli", icon: UsersRound },
  { to: "/genitore/attivita", label: "Attività", icon: ClipboardList },
  { to: "/genitore/calendario", label: "Calendario", icon: CalendarDays },
  { to: "/genitore/profilo", label: "Profilo", icon: UserRound },
];

export default function GenitoreLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  useRealtimeSync();
  const esci = async () => { await logout(); navigate("/login"); };
  const iniziali = `${(user?.nome || "G")[0]}${(user?.cognome || "")[0]}`.toUpperCase();

  return (
    <div className="min-h-dvh bg-[#FFFDF9] pb-24">
      <header className="max-w-5xl mx-auto px-4 sm:px-6 pt-5 pb-4 flex items-center gap-3">
        <NavLink to="/genitore" aria-label="Home area famiglia" className="shrink-0">
          <AppLogo size={48} className="drop-shadow-md" />
        </NavLink>
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-slate-400">Area famiglia</p>
          <p className="font-display font-extrabold text-slate-900 truncate">Ciao, {user?.nome || "Genitore"}</p>
        </div>
        <NavLink
          to="/genitore/profilo#notifiche"
          className="h-11 w-11 rounded-2xl bg-white border border-slate-100 shadow-sm text-slate-700 flex items-center justify-center hover:bg-slate-50 transition-colors"
          aria-label="Notifiche"
          data-testid="genitore-notifiche"
        >
          <Bell className="h-5 w-5" />
        </NavLink>
        <NavLink
          to="/genitore/profilo"
          className="h-11 w-11 rounded-2xl bg-amber-500 text-white font-display font-extrabold flex items-center justify-center shadow-sm hover:bg-amber-600 transition-colors"
          aria-label="Profilo"
        >
          {iniziali || "G"}
        </NavLink>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6">{children}</main>

      {/* Stessa pillola liquid-glass della navigazione degli altri ruoli. */}
      <nav className="fixed z-30 inset-x-4 bottom-[calc(0.75rem+env(safe-area-inset-bottom))] mx-auto max-w-md rounded-[2.25rem] bg-white/70 backdrop-blur-2xl backdrop-saturate-150 border border-white/60 shadow-[0_8px_32px_rgba(15,23,42,0.14)] flex justify-around items-center px-1.5 py-1.5" aria-label="Navigazione area famiglia">
        <div className="grid grid-cols-5 gap-1 w-full">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-2xl text-[10px] font-bold transition-all min-w-0 ${isActive ? "bg-amber-500/15 text-amber-600" : "text-slate-400 hover:bg-amber-50 hover:text-amber-600"}`}
              data-testid={`genitore-nav-${label.toLowerCase()}`}
            >
              <Icon className="h-5 w-5" />
              <span>{label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}

export { NAV as GENITORE_NAV };
